export enum AssigneeTypeEnum {
  EMAIL = 'EMAIL',
  GROUP = 'GROUP',
  USER = 'USER',
  VARIABLE = 'VARIABLE',
}
